import { isProductionEnvironment } from 'shared/envUtils';
import { useAuthState } from 'state/useAuthState';

export const useProgressionModelsEnabled = (): boolean => {
  const {
    permissions: { isInternalUser },
  } = useAuthState();

  if (!isProductionEnvironment()) {
    return true;
  }

  return isInternalUser;
};
